module.exports = __webpack_public_path__ + "img/Toolbox_Dark_Logo_RGB.27b57a92.png";